import styled from "styled-components";
import { useAppSelector } from "../../../../../../redux";
import { PostAudioProps } from "../../../../../../redux/slices/postAudio/postAudio";
import { PostsProps } from "../../../../../../redux/slices/posts/Posts";
import { AudioPlayer } from "../../../../../Common";
import { usePostCardContext } from "../PostCardContent";

export const AudioContent = () => {
  const { postId } = usePostCardContext();
  const { processed_posts } = useAppSelector((state) => state.newsfeed);

  const post = processed_posts[postId];
  if (!post) return null;

  const audios = post.media.audio;
  if (!audios || audios.length === 0) return null;

  const audioComponents = audios.map((audio) => (
    <AudioComponent
      key={audio.id}
      collaborators={post.collaborators}
      audio={{ ...audio }}
      postId={postId}
    />
  ));
  return <>{audioComponents}</>;
};

const AudioComponent = ({
  audio,
  collaborators,
  postId,
}: {
  audio: PostAudioProps.AudioMediaResponse;
  postId: string;
  collaborators: PostsProps.Collaborator[];
}) => {
  const { isOnExpandedPostView } = usePostCardContext();
  if (!audio.background_type) return <></>;

  return (
    <PaddingContainer $isOnExpandedPostView={isOnExpandedPostView}>
      <AudioPlayer
        {...{
          audio_description: audio.description,
          audio_path: audio.audio_path,
          audio_title: audio.title,
          audioBackgroundImage: {
            background_type: audio.background_type || "gradient",
            background_value: audio.background_value || "{}",
            id: audio.id,
            image_id: audio.image_id,
            post_id: postId,
          },
          id: audio.id,
          selectedCollaborator: collaborators,
        }}
        isViewOnly={false}
      />
    </PaddingContainer>
  );
};

const PaddingContainer = styled.div<{ $isOnExpandedPostView: boolean }>`
  ${({ $isOnExpandedPostView, theme }) =>
    $isOnExpandedPostView &&
    `
  padding: ${theme.spacing["spacing-2"].value}rem
    ${theme.spacing["spacing-4"].value}rem;`}
`;
